"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdsTextWidget = void 0;
var react_1 = __importDefault(require("react"));
var web_component_1 = require("./web-component");
var react_utils_1 = require("../utils/react-utils");
function PdsTextWidget(props) {
    return (react_1.default.createElement(web_component_1.WebComponent, { tag: "pds-text-widget", attributes: {
            name: react_utils_1.toAttribute(props.name),
            'data-label-text': react_utils_1.toAttribute(props.dataLabelText),
            'data-show-label': react_utils_1.toAttribute(props.dataShowLabel),
            'data-aria-label': react_utils_1.toAttribute(props.dataAriaLabel),
            'data-badge-text': react_utils_1.toAttribute(props.dataBadgeText),
            'data-tooltip-text': react_utils_1.toAttribute(props.dataTooltipText),
            'data-helper-text': react_utils_1.toAttribute(props.dataHelperText),
            'data-hide-unelevated-badge': react_utils_1.toAttribute(props.dataHideUnelevatedBadge),
            'data-disable-invalid-badge-elevation': react_utils_1.toAttribute(props.dataDisableInvalidBadgeElevation),
            'data-isrequired': react_utils_1.toAttribute(props.dataIsrequired),
            'data-use-alternate-color-scheme': react_utils_1.toAttribute(props.dataUseAlternateColorScheme),
            'data-customvalidate': react_utils_1.toAttribute(props.dataCustomvalidate),
            'data-use-valid-indicator': react_utils_1.toAttribute(props.dataUseValidIndicator),
            'data-regex-error-text': react_utils_1.toAttribute(props.dataRegexErrorText),
            'data-inverse-regex-error-text': react_utils_1.toAttribute(props.dataInverseRegexErrorText),
            'data-input-type': react_utils_1.toAttribute(props.dataInputType),
            'data-regex': react_utils_1.toAttribute(props.dataRegex),
            'data-regexmodifiers': react_utils_1.toAttribute(props.dataRegexmodifiers),
            'data-inverse-regex': react_utils_1.toAttribute(props.dataInverseRegex),
            'data-inverse-regexmodifiers': react_utils_1.toAttribute(props.dataInverseRegexmodifiers),
            'data-minlength': react_utils_1.toAttribute(props.dataMinlength),
            'data-maxlength': react_utils_1.toAttribute(props.dataMaxlength),
            'data-excludechars': react_utils_1.toAttribute(props.dataExcludechars),
            'data-is-email': react_utils_1.toAttribute(props.dataIsEmail),
            'data-show-password-rules': react_utils_1.toAttribute(props.dataShowPasswordRules),
            'data-placeholder-text': react_utils_1.toAttribute(props.dataPlaceholderText),
            'data-isreadonly': react_utils_1.toAttribute(props.dataIsreadonly),
            'data-isfieldonly': react_utils_1.toAttribute(props.dataIsfieldonly),
            'data-action-icon': react_utils_1.toAttribute(props.dataActionIcon),
            'autocomplete': react_utils_1.toAttribute(props.autocomplete),
            'data-show-password-link': react_utils_1.toAttribute(props.dataShowPasswordLink),
            'disabled': react_utils_1.toAttribute(props.disabled),
            class: react_utils_1.toAttribute(props.className)
        }, properties: {
            modelValue: props.modelValue,
            actionButtonClickHandler: props.actionButtonClickHandler
        }, listeners: {
            modelValueChange: function (event) {
                props.modelValueChange(event.target.modelValue);
            }
        } }));
}
exports.PdsTextWidget = PdsTextWidget;

//# sourceMappingURL=pds-text-widget.js.map
